@if (status === "loading") {
<div class="spinner">
    <img src="assets/spinner/spinner-1.svg" alt="Cargando datos">
</div>
}
<p class="h3-primary title">{{title}}</p>
<p class="body0-regular subtitle">{{subtitle}}</p>